import { __extends, __rest, __assign } from 'tslib';
import React__default from 'react';
import clsx from 'clsx';
import { propTypes, defaultProps } from './Radio.types.js';
import styles from './Radio.module.scss.js';

var Radio = /** @class */ (function (_super) {
    __extends(Radio, _super);
    function Radio() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Radio.prototype.componentDidMount = function () {
        if (this.props.testId) {
            console.warn('DEPRECATION WARNING: The `testId` prop is deprecated and support for it will be removed soon. Please use `data-testid` instead.');
        }
    };
    Radio.prototype.render = function () {
        var _a = this.props, label = _a.label, disabled = _a.disabled, size = _a.size, className = _a.className, testId = _a.testId, tabIndex = _a.tabIndex, inputProps = __rest(_a, ["label", "disabled", "size", "className", "testId", "tabIndex"]);
        return (React__default.createElement("label", { className: clsx(styles.RadioInput, styles["RadioInput___" + size], disabled && styles.RadioInput___disabled, className), tabIndex: tabIndex },
            React__default.createElement("span", { className: clsx(styles.HoverBackground, styles["HoverBackground___" + size]) }),
            label,
            React__default.createElement("input", __assign({ type: "radio", className: styles.RadioInput_inputElement, disabled: disabled, "data-testid": this.props['data-testid'] || testId }, inputProps)),
            React__default.createElement("span", { className: styles.RadioInput_check })));
    };
    Radio.displayName = 'Radio';
    Radio.propTypes = propTypes;
    Radio.defaultProps = __assign({}, defaultProps);
    return Radio;
}(React__default.Component));

export { Radio as default };
